module.exports = __webpack_public_path__ + "static/img/low.f1dd6869.png";